<template>
  <!-- 路由编辑页面 -->
  <div class="container">
    <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item
          label="大事记ID: "
          prop="bannerName"
          v-show="detailId"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="detailId"
              :disabled="detailId != ''"
              autocomplete="off"
              width="120px"
              placeholder="请输入"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="大事记地点: "
          prop="title"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.title"
              autocomplete="off"
              maxlength="100"
              show-word-limit
              placeholder="请输入大事记地点"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="大事记标题:"
          prop="subtitle"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.subtitle"
              autocomplete="off"
              maxlength="200"
              show-word-limit
              placeholder="请输入标题"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="大事记年份:"
          prop="year"
          :label-width="formLabelWidth"
        >
          <el-col :span="8">
            <el-date-picker
              v-model="form.year"
              value-format="yyyy"
              type="year"
              placeholder="请选择年份"
              :picker-options="startTime"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item
          label="大事记时间:"
          prop="mouth"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.mouth"
              placeholder="请输入月份"
              auto-complete="off"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="排序日期"
          prop="sortDate"
          :label-width="formLabelWidth"
        >
          <el-col :span="8">
            <el-date-picker
              v-model="form.sortDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
              :picker-options="sortStartTime"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <!-- 修改状态: 0 已发布, 1 未发布 -->
      <div slot="footer" class="dialog-button" v-if="detailId">
        <el-button type="primary" @click="handelConfirm('form', 0)">
          发 布
        </el-button>
        <el-button class="confirm-button" @click="handelConfirm('form', 1)"
          >保 存</el-button
        >
      </div>
      <div slot="footer" class="dialog-button" v-else>
        <el-button type="primary" @click="handelConfirm('form', 0)">
          立即创建
        </el-button>
        <el-button class="confirm-button" @click="resetForm('form')"
          >重 置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// import { Message } from 'element-ui'
import bigEventApi from '@/api/bigEvent/index.js'
import { mapRequestActions } from '@/utils'
export default {
  data () {
    return {
      loading: false,
      formLabelWidth: '150px',
      detailId: this.$route.query.id || '',
      detailList: {},
      form: {
        title: '',
        subtitle: '',
        year: '',
        mouth: '',
        sortDate: ''
      },
      startTime: {
        disabledDate: time => {
          if (this.form.year) {
            return (
              time.getTime() > new Date(this.form.year).getTime()// 这里的this.params.endData按自己的字段参数来
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      sortStartTime: {
        disabledDate: time => {
          if (this.form.sortDate) {
            return (
              time.getTime() > new Date(this.form.sortDate).getTime()// 这里的this.params.endData按自己的字段参数来
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      rule: {
        subtitle: [
          { required: true, message: '请输入大事记标题', trigger: 'change' },
          {
            min: 1,
            max: 200,
            message: '请输入长度1～200个字符',
            trigger: 'change'
          }
        ],
        year: [{ required: true, message: '请选择年份', trigger: 'change' }],
        mouth: [{ required: true, message: '请输入月份', trigger: 'change' }],
        sortDate: [
          { required: true, message: '请选择排序日期', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (this.detailId) {
      this.handleQueryDetailById()
    }
  },
  methods: {
    ...mapRequestActions(bigEventApi),
    handelConfirm (formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑状态 且 点击发布
          if (this.detailId && type === 0) {
            this.updateBigEventAction({
              id: this.detailId,
              title: this.form.title,
              status: type,
              subtitle: this.form.subtitle,
              year: this.form.year,
              mouth: this.form.mouth,
              sortDate: this.form.sortDate
            }).then((res) => {
              if (res.status) {
                this.$message.success('编辑成功！')
              } else {
                this.$message.error('操作失败')
              }
            })
          } else if (this.detailId && type === 1) {
            // 编辑状态 且 点击保存
            this.updateBigEventAction({
              id: this.detailId,
              title: this.form.title,
              status: type,
              subtitle: this.form.subtitle,
              year: this.form.year,
              mouth: this.form.mouth,
              sortDate: this.form.sortDate
            }).then((res) => {
              if (res.status) {
                this.$message.success('保存成功！')
              } else {
                this.$message.error('操作失败')
              }
            })
          } else {
            // 点击新增数据
            this.addBigEventAction({
              title: this.form.title,
              status: type,
              subtitle: this.form.subtitle,
              year: this.form.year,
              mouth: this.form.mouth,
              sortDate: this.form.sortDate
            }).then((res) => {
              if (res.status) {
                this.$message.success('新增成功！')
              } else {
                this.$message.error('操作失败')
              }
            })
          }
          this.$router.push('/big-event')
        } else {
          // todo
        }
      })
    },
    /**
     * 重置
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },

    async handleQueryDetailById () {
      const resultData = await this.queryDetailByIdAction({
        id: this.detailId
      })
      if (resultData.status) {
        this.form.title = resultData.result.title
        this.form.subtitle = resultData.result.subtitle
        this.form.year = resultData.result.year
        this.form.mouth = resultData.result.mouth
        this.form.sortDate = resultData.result.sortDate
      }
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
}
.el-form {
  max-width: 80%;
  min-width: 800px;
  margin-right: auto;
  padding: 20px 30px;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 125px;
    height: 125px;
  }
  .address {
    /deep/ .el-form-item__label:before {
      content: "*" !important;
      color: #f56c6c !important;
      margin-right: 4px !important;
    }
  }
}
.div-upload-form-item {
  position: relative;
  .div-upload-bottom {
    position: absolute;
    right: 0;
    top: 100px;
  }
  .div-upload-container {
    display: block;
    height: 135px;
    float: left;
    overflow: hidden;
    transition: height 0.75s;
    /deep/ .el-upload {
      width: 125px;
      height: 125px;
      line-height: 125px;
    }
  }
}
.el-upload-dragger .el-icon-upload {
  margin: 25px 0 16px;
}
.dialog-button {
  text-align: left;
  margin-left: 20%;
  margin-top: 40px;
  .confirm-button {
    margin-left: 30px;
  }
}
.el-col {
  text-align: left;
}
</style>
